export const MAX_CHARACTERS = 15;
export const MAX_TAGS = 6;
export const MIN_TAGS = 0;

export const TAG_PREFIX = '';
